module.exports = __webpack_public_path__ + "img/Group 4469.68c08a42.svg";